export default {
  meta: {
    title: '广告位编辑'
  }
};
